import React from 'react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ForumIcon from '@mui/icons-material/Forum';
import MapIcon from '@mui/icons-material/Map';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { SEARCH_RESULT_TYPES } from '../services/searchService';

/**
 * Get color based on result type
 */
export const getTypeColor = (type) => {
  switch (type) {
    case SEARCH_RESULT_TYPES.CAMPAIGN_EPISODE:
      return '#d98d2a';
    case SEARCH_RESULT_TYPES.POST:
      return '#4CAF50';
    case SEARCH_RESULT_TYPES.MAP:
      return '#2196F3';
    case SEARCH_RESULT_TYPES.PIN:
      return '#FF9800';
    case SEARCH_RESULT_TYPES.ACCOLADE:
      return '#FFD700';
    case SEARCH_RESULT_TYPES.JOURNAL:
    case SEARCH_RESULT_TYPES.JOURNAL_PDF_CONTENT:
      return '#9C27B0';
    case SEARCH_RESULT_TYPES.WIKI:
      return '#B08D57';
    default:
      return '#757575';
  }
};

/**
 * Get readable type label
 */
export const getTypeLabel = (type) => {
  switch (type) {
    case SEARCH_RESULT_TYPES.CAMPAIGN_EPISODE:
      return 'Episode';
    case SEARCH_RESULT_TYPES.POST:
      return 'Post';
    case SEARCH_RESULT_TYPES.MAP:
      return 'Map';
    case SEARCH_RESULT_TYPES.PIN:
      return 'Pin';
    case SEARCH_RESULT_TYPES.ACCOLADE:
      return 'Accolade';
    case SEARCH_RESULT_TYPES.JOURNAL:
      return 'Journal';
    case SEARCH_RESULT_TYPES.JOURNAL_PDF_CONTENT:
      return "Benny's Journal";
    case SEARCH_RESULT_TYPES.WIKI:
      return 'Wiki';
    default:
      return 'Result';
  }
};

/**
 * Get icon component based on result type
 */
export const getTypeIcon = (type) => {
  switch (type) {
    case SEARCH_RESULT_TYPES.CAMPAIGN_EPISODE:
      return <CalendarTodayIcon />;
    case SEARCH_RESULT_TYPES.POST:
      return <ForumIcon />;
    case SEARCH_RESULT_TYPES.MAP:
      return <MapIcon />;
    case SEARCH_RESULT_TYPES.PIN:
      return <LocationOnIcon />;
    case SEARCH_RESULT_TYPES.ACCOLADE:
      return <EmojiEventsIcon />;
    case SEARCH_RESULT_TYPES.JOURNAL:
      return <MenuBookIcon />;
    case SEARCH_RESULT_TYPES.JOURNAL_PDF_CONTENT:
      return <PictureAsPdfIcon />;
    case SEARCH_RESULT_TYPES.WIKI:
      return <MenuBookIcon />;
    default:
      return <MenuBookIcon />;
  }
};

/**
 * Format date for display
 */
export const formatDate = (timestamp) => {
  if (!timestamp) return '';
  
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

/**
 * Parse description with bold markdown (**text**)
 */
export const parseDescription = (description) => {
  if (!description) return null;
  
  // Split by **bold** markers
  const parts = description.split(/(\*\*.*?\*\*)/g);
  
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      // Bold text
      const text = part.slice(2, -2);
      return <strong key={index} style={{ fontWeight: 700, color: '#d98d2a' }}>{text}</strong>;
    }
    return <span key={index}>{part}</span>;
  });
};